import React from 'react';
import { Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const DatasetConvertToastComplete = ({ datasetName }) => (
  <div className="aridhia-dataset-convert-complete-toast toast-success toast-message">
    <Icon name="check circle" color="green" />
    <FormattedMessage id="dataset.convert.toast.update.dictionaries.complete" values={{ datasetName }} />
  </div>
);

export default DatasetConvertToastComplete;
